import React from 'react';
import { Link } from 'react-router-dom';

function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

const Header = () => {

	async function showRazorpay () {
        const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
    
        if (!res) {
          alert("Razorpay SDK failed to load. Try rechecking your connection!");
          return;
        }
    
        const data = await fetch("https://akshatngupta-bike-rental.herokuapp.com/verification", {
          method: "POST",
        }).then((t) => t.json());
    
        console.log(data);
		JSON.stringify(data);
        const options = {
          key: "rzp_test_QPKPVriGwgjAML",
          currency: data.currency,
          amount: 50000,
          order_id: data.id,
          name: "Bike Rental",
          description: "Help Us Serve you better!",
          image: "https://akshatngupta-bike-rental.herokuapp.com/logo.svg",
          handler: function (response) {
            // alert(response.razorpay_payment_id);
            // alert(response.razorpay_order_id);
            // alert(response.razorpay_signature);
    
            alert("Transaction successful");
          },
          prefill: {
            // name: "Akshat",
            // email: "akshat.narayangupta@gmail.com",
            // phone_number: "7667932231",
          },
        };
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      }

	let authuser = sessionStorage.getItem('Key_Veriable')
  //console.log(authuser)
    if (authuser === 'ADMIN') {
		return (
			<div className='header'>
				<div className='container'>
					<div className='row v-center space-between'>
							<div className='menu-item'>
							<ul>
								<div className='logo'>Bike Rental</div>
								<Link to="/"><button className='button'>Home</button></Link>
								<Link to="/adminafterlogin"><button className='button'>Dashboard</button></Link>
								<Link to="/manageusers"><button className='button'>Users</button></Link>
								<Link to="/managebookings"><button className='button'>Bookings</button></Link>
								<Link to="/logout"><button className='button'>Log-Out</button></Link>
							</ul>
						</div>
					</div>
				</div>
			</div>
		)
	}
	else if (authuser === 'USER') {
		return (
			<div className='header'>
				<div className='container'>
					<div className='row v-center space-between'>
							<div className='menu-item'>
							<ul>
								<div className='logo'>Bike Rental</div>
								<Link to="/"><button className='button'>Home</button></Link>
								<Link to="/userafterlogin"><button className='button'>Dashboard</button></Link>
								<Link to="/updateprofile"><button className='button'>Profile</button></Link>
								<Link to="/makebooking"><button className='button'>Booking</button></Link>
								<Link to="/showallmybooking"><button className='button'>My Bookings</button></Link>
								<button className="helpus" onClick={showRazorpay} >Donate</button>
								<Link to="/logout"><button className='button'>Log-Out</button></Link>
							</ul>
						</div>
					</div>
				</div>
			</div>
		)
	}
	else {
		return (
			<div className='header'>
				<div className='container'>
					<div className='row v-center space-between'>
						
							<div className='menu-item'>
							<ul>
								<div className='logo'>Bike Rental</div>
								<Link to="/"><button className='button'>Home</button></Link>
								<Link to="/signin"><button className='button'>SignIn </button></Link>
								<Link to="/signup"><button className='button'>SignUp</button></Link>
								<button className='button' onClick={()=>window.location.replace("/#about1")}>About</button>
								<button className='button' onClick={()=>window.location.replace("/#fleet1")}>Fleets</button>
								<button className='button' onClick={()=>window.location.replace("/#ourteam1")}>Team</button>
								<button className='button' onClick={()=>window.location.replace("/#featured1")}>Featured</button>
								<button className="helpus" onClick={showRazorpay} >Donate</button>
								<Link to="/help"><button className='button' id="rotate">More</button></Link>
							</ul>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default Header
